const SHIPPERS = {
  GET_ALL_PUBLIC_SHIPPERS: "GET_ALL_PUBLIC_SHIPPERS",
  FILTERING: "FILTERING",
  FILTER_PUBLIC_SHIPPERS: "FILTER_PUBLIC_SHIPPERS",
  FILTER_SHIPPERS_NOPAGE: "FILTER_SHIPPERS_NOPAGE",
  SEARCH_SHIPPERS: "SEARCH_SHIPPERS",
  SHOW_SHIPPERS: "SHOW_SHIPPERS",
  SHOW_MY_SHIPPERS: "SHOW_MY_SHIPPERS",
  LOADING_PUBLIC_SHIPPERS: "LOADING_PUBLIC_SHIPPERS",
  LOADING_SEARCH: "LOADING_SEARCH",
  STORE_CURRENT_SHIPPER: "STORE_CURRENT_SHIPPER",
};

export default SHIPPERS;
